import {
  Box,
  Button,
  Divider,
  Drawer,
  IconButton,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Tabs,
  Tab,
  MenuItem,
  Select,
  SelectChangeEvent,
} from "@mui/material";
import ReceiptIcon from "@mui/icons-material/Receipt";
import { useNavigate } from "react-router-dom";
import { useState } from "react";
import SearchBar from "../../../components/SearchBar";
import React from "react";

interface TabPanelProps {
  children?: React.ReactNode;
  index: number;
  value: number;
}

function CustomTabPanel(props: TabPanelProps) {
  const { children, value, index, ...other } = props;
  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      {...other}
    >
      {value === index && <>{children}</>}
    </div>
  );
}

function a11yProps(index: number) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

const OrderManagement = () => {
  const navigate = useNavigate();
  const [searchTerm, setSearchTerm] = useState("");
  const [orderTab, setOrderTab] = useState(0);
  const [isDrawerOpen, setIsDrawerOpen] = useState(false);
  const [selectedOrder, setSelectedOrder] = useState<any | null>(null);

  const tabLabels = [
    "Order Confirmed",
    "Shipped",
    "Out for Delivery",
    "Delivered",
  ];

  const orderData = [
    {
      orderId: "#ORD_001",
      user: {
        name: "John Doe",
        email: "john.doe@example.com",
        phone: "+91 9876543210",
      },
      yoghurtQuantity: "Small",
      yoghurtFlavor: "Mango",
      yoghurtToppings: "Mango Chunks, Pistachios, Honey Drizzle",
      totalUnits: 2,
      paymentDetails: "Paid via Credit Card",
      orderDateTime: "29 Oct 2025, 10:30 AM",
      deliveryDateTime: "29 Oct 2025, 11:00 AM",
      store: "#ST001 - Downtown Store",
      status: "Order Confirmed",
    },
    {
      orderId: "#ORD_002",
      user: {
        name: "Alice Smith",
        email: "alice.smith@example.com",
        phone: "+1 222 333 4444",
      },
      yoghurtQuantity: "Large",
      yoghurtFlavor: "Strawberry",
      yoghurtToppings: "Strawberry Chunks, Almonds, Chocolate Syrup",
      totalUnits: 1,
      paymentDetails: "Paid via PayPal",
      orderDateTime: "28 Oct 2025, 09:15 AM",
      deliveryDateTime: "28 Oct 2025, 09:45 AM",
      store: "#ST001 - Downtown Store",
      status: "Shipped",
    },
  ];

  const handleViewOrder = (order: any) => {
    setSelectedOrder(order);
    setIsDrawerOpen(true);
  };

  const handleCloseDrawer = () => {
    setIsDrawerOpen(false);
    setSelectedOrder(null);
  };

  const [Status, setStatus] = React.useState('default');
  const handleStatusChange = (event: SelectChangeEvent) => {
    setStatus(event.target.value as string);
  };

  return (
    <>
      <div className="main_title">
        <h1>Order Management</h1>
        <p>
          <button onClick={() => navigate("/dashboard")}>Dashboard</button> - Order Management
        </p>
      </div>

      {/* Tabs */}

      <div className="table_header">
        <div className="left_s">
          <Box className="custom_tabs1" sx={{ width: "100%" }}>
            <Tabs
              value={orderTab}
              onChange={(e, newValue) => setOrderTab(newValue)}
              className="custom_tabs_links"
            >
              {tabLabels.map((label, index) => (
                <Tab key={index} label={label} {...a11yProps(index)} />
              ))}
            </Tabs>
          </Box>
        </div>
      </div>

      {/* Table */}
      <div className="cards">
        {tabLabels.map((_, tabIndex) => (
          <CustomTabPanel key={tabIndex} value={orderTab} index={tabIndex}>
            <div className="table_header">
              <Box className="search_box">
                <SearchBar
                  searchTerm={searchTerm}
                  setDebouncedSearchTerm={setSearchTerm}
                  placeholder="Search orders..."
                />
                <div className=" form">
                  <Select
                    fullWidth
                    value={Status}
                    onChange={handleStatusChange} >
                    <MenuItem disabled value="default">Select Store</MenuItem>
                    <MenuItem value="1">#ST001 - Downtown Store</MenuItem>
                    <MenuItem value="2">#ST002 - City Mall Store</MenuItem>
                    <MenuItem value="3">#ST003 - Central Plaza</MenuItem>
                  </Select>
                </div>
              </Box>
            </div>

            <TableContainer className="table_container">
              <Table>
                <TableHead>
                  <TableRow>
                    <TableCell>Order ID</TableCell>
                    <TableCell>Store Detail</TableCell>
                    <TableCell>User Details</TableCell>
                    <TableCell>Yoghurt Size</TableCell>
                    <TableCell>Yoghurt Flavor</TableCell>
                    <TableCell>Yoghurt Toppings</TableCell>
                    <TableCell>Total Units</TableCell>
                    <TableCell>Payment Details</TableCell>
                    <TableCell>Date & Time of Order</TableCell>
                    <TableCell>Delivery Date & Time</TableCell>
                    <TableCell>Action</TableCell>
                  </TableRow>
                </TableHead>

                <TableBody>
                  {orderData
                    .filter((order) =>
                      tabIndex === 0
                        ? order.status === "Order Confirmed"
                        : order.status === tabLabels[tabIndex]
                    )
                    .map((order, index) => (
                      <TableRow hover key={index}>
                        <TableCell>{order.orderId}</TableCell>
                        <TableCell>
                          <a href="/manage-stores/detail" className="click_action" onClick={() => navigate("/manage-stores/detail")}>
                            <b>{order.store}</b>
                          </a>
                        </TableCell>
                        <TableCell>
                          <Box className="user_block">
                            <figure>
                              <img
                                src="/static/images/user_placeholder.png"
                                alt="User"
                              />
                            </figure>
                            <p>
                              <b>{order.user.name}</b>
                              <span>{order.user.email}</span>
                              <span>{order.user.phone}</span>
                            </p>
                          </Box>
                        </TableCell>
                        <TableCell>{order.yoghurtQuantity}</TableCell>
                        <TableCell>{order.yoghurtFlavor}</TableCell>
                        <TableCell>{order.yoghurtToppings}</TableCell>
                        <TableCell>{order.totalUnits}</TableCell>
                        <TableCell>{order.paymentDetails}</TableCell>
                        <TableCell>{order.orderDateTime}</TableCell>
                        <TableCell>{order.deliveryDateTime}</TableCell>
                        <TableCell>
                          <div className="table_actions v2">
                            <IconButton>
                              <img onClick={() => navigate('view')} src="/static/images/eye_icon.svg" alt="View" />
                            </IconButton>
                            <IconButton>
                              <ReceiptIcon />
                            </IconButton>
                          </div>
                        </TableCell>
                      </TableRow>
                    ))}
                </TableBody>
              </Table>
            </TableContainer>
          </CustomTabPanel>
        ))}
      </div>


    </>
  );
};

export default OrderManagement;
